// Componentes

import SendProposal from '@/components/supplier/offer-details/modal/send-proposal/';
import EnterpriseQuotation from '@/components/supplier/enterprise/';

import Breadcrumb from '@/components/supplier/offer-details/breadcrumb';
import exportPdf from '@/components/supplier/offer-details/export-pdf';
// Requisição
import { getOffers, getCompetitionData, getSubscription } from '@/services';
import { mapActions, mapState } from 'vuex';

import { getEngelinkAds, sendEngelinkAdsClicks } from '@/services/api/marketing';

export default {
    name: 'OffersDetails',
    components: {
        Breadcrumb,
        exportPdf,
        SendProposal,
        // Modais de alerta
        EnterpriseQuotation
    },
    props: {
        isMobile: [Boolean, Object]
    },
    data: () => ({
        loading: true,
        competition: {
            links: {
                links: []
            },
            questions: {
                questions: []
            },
            nextSlot: {
                price: 0
            }
        },
        offer: {},
        quotationParticipating: false,
        source: [
            { label: 'Oportunidades', route: '/fornecedor/minhas-cotacoes' },
            { label: 'Detalhes da cotação enterprise', route: '' }
        ],
        showModal: false,
        alertModal: false,
        subscription: {},
        supplier: {},
        isSubscriber: true,
        planType: '',
        campaign: {}
    }),
    async created() {
        await this.initializeData();
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        async initializeData() {
            this.loading = true;
            await this.getSubcription();
            const offers = await this.getOffers();
            this.offer = offers;
            const competition = this.guest ? false : await this.getCompetitionData();
            this.competition = competition ? competition : offers.competitionData;
            this.loading = false;
            const { data } = await getEngelinkAds(
                `?location=competition-panel&competition=${this.competition.id}&device=${this.deviceCampaign}`
            );
            this.campaign = data;
        },
        showModalToggle(toggle) {
            this.showModal = toggle;
        },
        async getSubcription() {
            try {
                const { data, error } = await getSubscription();
                if (!error) {
                    this.planType = data.isActive ? data.plan.sort : null;
                    this.subscription = data;
                }
            } catch (e) {
                console.log(e);
            }
        },
        async getOffers() {
            const { offers } = await getOffers(this.$route.params.id);
            return offers;
        },
        async getCompetitionData() {
            const { data } = await getCompetitionData(this.offer.competitionData.id);
            return data;
        },
        async sendClick(data) {
            window.open(data.urlRedirect, '_blank');
            try {
                await sendEngelinkAdsClicks({
                    campaign: data.campaign,
                    device: data.device,
                    location: data.location,
                    state: this.supplierState,
                    tag: data.tag
                });
            } catch (error) {
                console.error(error);
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['supplierData']),
        modalHeight() {
            return '60%';
        },
        isEnterprise() {
            return this.competition.isEnterprise;
        },
        deviceCampaign: function() {
            return window.innerWidth <= 768 ? 'mobile' : 'desktop';
        },
        supplierState: function() {
            return this.supplierData.supplierState;
        }
    },
    watch: {
        isEnterprise(newValue) {
            if (newValue) {
                if (this.$route.name != 'Enterprise') {
                    this.$router.push({
                        name: 'Enterprise',
                        params: {
                            id: this.offer.id
                        }
                    });
                }
            } else {
                if (this.$route.name != 'OffersDetails') {
                    this.$router.push({
                        name: 'OffersDetails',
                        params: {
                            tag: this.offer.tagSlug ? this.offer.tagSlug : 'outra',
                            id: this.offer.id
                        }
                    });
                }
            }
        }
    }
};
